import React, { useContext } from 'react';
import CreateRating from './CreateRating';
import { WindowManagerContext } from '../context/WindowManager';
import Signup from './Signup';
import LoadingWindow from './LoadingWindow';
import NotificationWindow from './NotificationWindow';
import Login from './Login';
import PreFilterWindow from './PreFilterWindow';
import CookieWindow from './CookieWindow';
import WizardWindow from './WizardWindow';

const windowComponents = {
  createRating: (props) => <CreateRating {...props} />,
  signup: (props) => <Signup {...props} />,
  loading: (props) => <LoadingWindow {...props} />,
  notification: (props) => <NotificationWindow {...props} />,
  login: (props) => <Login {...props} />,
  preFilter: (props) => <PreFilterWindow {...props} />,
  chooseCookie: (props) => <CookieWindow {...props} />,
  wizard: (props) => <WizardWindow {...props} />
};

const closeCurrentWindow = (windows, closeWindow) => {
  let currentWindowName = null;
  let currentZIndex = 0;
  Object.entries(windows).forEach(([key, value]) => {
    if (value.open) {
      if (value.zIndex > currentZIndex) {
        currentWindowName = key;
        currentZIndex = value.zIndex;
      }
    }
  });
  closeWindow(currentWindowName);
};

const WindowsHolder = (props) => {
  const { windows, windowBackgroundZIndex, closeWindow } = useContext(WindowManagerContext);
  const [anyWindowOpen, setAnyWindowOpen] = React.useState(false);
  // const [backgroundZIndex, setBackgroundZIndex] = React.useState(windowBackgroundZIndex);

  React.useEffect(() => {
    setAnyWindowOpen(false);
    Object.keys(windows).map(windowName => {
      if (windows[windowName].open) {
        setAnyWindowOpen(true);
      }
      return null;
    });
  }, [windows]);

  return (
    <>
      {
        Object.keys(windows).map(windowName => {
          const { zIndex, open, props } = windows[windowName];
          if (open) {
            return (
              <React.Fragment key={windowName}>
                {
                  windowComponents[windowName]
                    ? windowComponents[windowName]({
                        ...props,
                        close: () => { closeWindow(windowName); },
                        style: { ...props.style, zIndex },
                        className: props.className + (open ? ' window-open' : ' window-closed')
                      })
                    : null
                }
              </React.Fragment>
            );
          } else {
            return null;
          }
        })
      }
      <div
        className={'window-background' + (anyWindowOpen ? '-open' : '-closed')}
        onClick={() => closeCurrentWindow(windows, closeWindow)}
        style={{
          zIndex: windowBackgroundZIndex,
          height: '100vh',
          width: '100%',
          position: 'fixed',
          top: 0,
          left: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.6)'
        }}
      />
      {props.children}
    </>
  );
};

export default WindowsHolder;
